
define('text!modules/targeting/digital/templates/search_results.html',[],function () { return '{{#results}}\n    {{>gridSubItem}}\n{{/results}}';});

